import styled from 'styled-components';
import { useModalsContext } from 'modules/sendingPlatforms/contexts';
import { MergedSmsSender } from 'modules/sendingPlatforms/types';
import { Disconnect, Edit24 } from 'ui/icons';
import { Caption, colors } from 'ui/theme';
import { OverflowMenu } from 'ui/actionMenu';
import { AllowedActionMenuElements, MENU_ALIGNMENTS } from 'ui/actionMenu/types';
import { BottomTooltip } from 'ui/tooltip';
import { Detail, Details, ID, Name, RightContent, Row } from '../Email/EmailChannelRow.styled';

export const SMS_SENDER_ROW_TEXT = {
  DISCONNECT_ID: 'disconnect-message-profile',
  DISCONNECT_MESSAGE: 'Disconnect message profile',
  EDIT_ID: 'edit-message-profile',
  EDIT_MESSAGE: 'Edit message profile',
  MENU_ID: 'messaging-service-options',
  NOT_CONNECTED: 'Not connected to message type',
  TOOLTIP:
    'When a user texts in to unsubscribe, they will be unsubscribed only from this message type, rather than all SMS channels.',
};

export const TooltipText = styled(Caption)`
  color: ${colors.white};
  display: block;
  text-align: center;
`;

export type Props = {
  smsSender: MergedSmsSender;
};

export const SmsSenderRow = ({ smsSender }: Props) => {
  const { id, name, messageType } = smsSender;
  const { showDeleteSmsSenderModal, showEditSmsSenderModal } = useModalsContext();
  const handleEditAction = () => showEditSmsSenderModal(smsSender);
  const handleDeleteAction = () => showDeleteSmsSenderModal(smsSender);

  return (
    <Row>
      <div>
        <Name>{name}</Name>
        <Details>
          <ID>ID {id}</ID>
          <BottomTooltip
            isEnabled={!!messageType}
            isUnderlined
            tooltipContent={<TooltipText>{SMS_SENDER_ROW_TEXT.TOOLTIP}</TooltipText>}
          >
            <Detail>{messageType ? messageType.name : SMS_SENDER_ROW_TEXT.NOT_CONNECTED}</Detail>
          </BottomTooltip>
        </Details>
      </div>
      <RightContent>
        <OverflowMenu
          id={SMS_SENDER_ROW_TEXT.MENU_ID}
          isDisabled={false}
          options={[
            {
              as: AllowedActionMenuElements.Button,
              content: (
                <>
                  <Edit24 />
                  <span>{SMS_SENDER_ROW_TEXT.EDIT_MESSAGE}</span>
                </>
              ),
              id: SMS_SENDER_ROW_TEXT.EDIT_ID,
              isDisabled: false,
              onClick: handleEditAction,
            },
            {
              as: AllowedActionMenuElements.Button,
              content: (
                <>
                  <Disconnect />
                  <span>{SMS_SENDER_ROW_TEXT.DISCONNECT_MESSAGE}</span>
                </>
              ),
              id: SMS_SENDER_ROW_TEXT.DISCONNECT_ID,
              onClick: handleDeleteAction,
            },
          ]}
          position={MENU_ALIGNMENTS.RIGHT}
        />
      </RightContent>
    </Row>
  );
};
